import {StyleSheet} from "aphrodite";
import * as React from "react";

import {addStyle, type StyleType} from "@khanacademy/wonder-blocks-core";
import Link from "@khanacademy/wonder-blocks-link";
import {color, spacing} from "@khanacademy/wonder-blocks-tokens";

import Shimmer from "#components/shimmer-package/shimmer.tsx";

import FooterDomainsQuery, {
    type FooterDomainsQueryResult,
} from "./footer-domains-query.ts";

const StyledLi = addStyle("li");

type Props = {
    /**
     * Custom styles for the items
     */
    style?: StyleType;
};

/**
 * A component that gets the available domains and renders them using a list
 */
export default class FooterDomains extends React.Component<Props> {
    /**
     * Display a skeleton placeholder before getting any data
     */
    renderPlaceholder(): React.ReactNode {
        return (
            <Shimmer>
                <ul>
                    <StyledLi style={styles.skeleton} />
                    <StyledLi style={styles.skeleton} />
                    <StyledLi style={styles.skeleton} />
                </ul>
            </Shimmer>
        );
    }

    render(): React.ReactNode {
        const {style} = this.props;

        return (
            <FooterDomainsQuery>
                {({loading, error, domains}: FooterDomainsQueryResult) => {
                    if (loading) {
                        return this.renderPlaceholder();
                    }
                    if (domains) {
                        return (
                            <ul>
                                {domains.map((domain, i) => (
                                    <StyledLi style={style} key={i}>
                                        <Link light={true} href={domain.href}>
                                            {domain.translatedTitle}
                                        </Link>
                                    </StyledLi>
                                ))}
                            </ul>
                        );
                    }
                    return null;
                }}
            </FooterDomainsQuery>
        );
    }
}

const styles = StyleSheet.create({
    skeleton: {
        background: color.white50,
        height: spacing.medium_16,
        marginBottom: spacing.medium_16,
        paddingRight: spacing.medium_16,
    },
});
